import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";
import { objToParams } from "../../utils/func";

const initialState = {
  loading: false,
  error: null,
  corporates: [],
 corporateDetails: "",
//   feePaymentDetail: "",
//   feepaymentId: "",
//   paymentConfirmation: false,
  corporatesParams: {
    status: "Pending",
    page: 1,
    pageSize: 5,
  },
};

export const fetchCorporateApplicationApproval = createAsyncThunk(
  "corporateApplicationApproval/fetchCorporateApplicationApproval",
  async (arg, { getState }) => {
    return httpRequest(
      `${BASE_URL}/v2/Application/all-corporate-applications${objToParams(
        getState()?.corporateApplicationApproval?.corporatesParams
      )}`
    );
  }
);

export const fetchCorporateDetails = createAsyncThunk(
  "corporateApplicationApproval/fetchCorporateDetails",
  async (id) => {
    return httpRequest(`${BASE_URL}/v2/Application/${id}/corporate-details`);
  }
);

export const approveCorporateApplication = createAsyncThunk(
  "corporateApplicationApproval/approveCorporateApplication",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Application/approve-corporate`,
        "post",
        arg
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const corporateApplicationApprovalSlice = createSlice({
  name: "corporateApplicationApproval",
  initialState,
  reducers: {
    setCorporateDetails: (state, { payload }) => {
      state.corporateDetails = payload;
    },
    setFeePaymentDetail: (state, { payload }) => {
      state.feePaymentDetail = payload;
    },
    setFeepaymentId: (state, { payload }) => {
      state.feepaymentId = payload;
    },
    setPaymentConfirmation: (state, { payload }) => {
      state.paymentConfirmation = payload;
    },
    setUpdateCorporatesStatus: (state, { payload }) => {
      state.corporatesParams.status = payload;
      state.corporates = [];
    },
    setUpdateCorporatesPagination: (state, { payload }) => {
      state.corporatesParams.page = payload;
      state.corporates = [];
    },
    setUpdateCorporatesPageSize: (state, { payload }) => {
      state.corporatesParams.pageSize = payload;
      state.corporates = [];
    },
  },
  extraReducers: (builder) => {
    //  get corporate applications:
    builder.addCase(fetchCorporateApplicationApproval.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchCorporateApplicationApproval.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.corporates = payload;
        state.error = null;
      }
    );
    builder.addCase(
      fetchCorporateApplicationApproval.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    );

    //  get corporate details:
    builder.addCase(fetchCorporateDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCorporateDetails.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.corporateDetails = payload;
      state.error = null;
    });
    builder.addCase(fetchCorporateDetails.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    //  approve corporate application:
    builder.addCase(approveCorporateApplication.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      approveCorporateApplication.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.error = null;
      }
    );
    builder.addCase(
      approveCorporateApplication.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    );
  },
});

export const {
  setCorporateDetails,
  setFeePaymentDetail,
  setFeepaymentId,
  setPaymentConfirmation,
  setUpdateCorporatesStatus,
  setUpdateCorporatesPagination,
  setUpdateCorporatesPageSize,
} = corporateApplicationApprovalSlice.actions;
export default corporateApplicationApprovalSlice.reducer;
